// API_URL may carry its own scheme (e.g. https://tst-teleapi.minumarketing.com).
// Only fall back to http:// when the build-time value is bare host[:port], so a
// bundle can be built for an HTTPS origin without being patched afterwards.
const RAW_API_URL = process.env.API_URL || 'localhost:8000';
export const API_ROOT = /^https?:\/\//.test(RAW_API_URL)
  ? RAW_API_URL
  : 'http://' + RAW_API_URL;
export const LOGIN_URL = `${API_ROOT}/login/`;
export const API_URL = `${API_ROOT}/graphql/`;
export const EMAIL_REPORT_API_URL = `${API_ROOT}/report/email`;

// Authorization MUST be a getter, not a captured value. This object is created
// once at module load, but the token only exists in localStorage after login --
// and login is a client-side route change (history.push), not a page reload, so
// nothing re-evaluates it. Capturing the value meant every request made during
// the session in which the user logged in carried `Authorization: null`.
//
// That is currently harmless only because the GraphQL endpoint does not check
// credentials. It must be fixed BEFORE authentication is enforced, or the
// post-login query would 401 and UserContext would spin forever.
//
// requestapijs reads these properties per request (Api.post/graphql take the
// headers object as an argument), so the getter is evaluated at request time.
export const HEADER = {
  get Authorization() {
    return localStorage.getItem('token');
  },
  'content-type': 'application/json',
};
